import {EditableFieldModel} from "@white-label/components/page-builder/models/edit-component.model";
import {FieldType} from "@white-label/components/page-builder/models/model.map";

export class HeaderLiveBannerModel {
    listenToChannel = new EditableFieldModel('listen_to_channel_for_live', FieldType.link, '');
    videoUrl = new EditableFieldModel('video_url', FieldType.link, '');
    liveVideoUrl = new EditableFieldModel('live_video_url', FieldType.link, '');
    // logoUrl = new EditableFieldModel('logo_url', FieldType.image, '');
    description = new EditableFieldModel('description', FieldType.textarea, '');
    // channelName = new EditableFieldModel('channel_name', FieldType.text, '');
    subscriberCount = new EditableFieldModel('subscribers_count', FieldType.number, '');
    videoCount = new EditableFieldModel('video_count', FieldType.number, '');
    likesCount = new EditableFieldModel('like_count', FieldType.number, '');
    totalViewCount = new EditableFieldModel('total_view_count', FieldType.number, '');

    fieldsMap = [
        this.listenToChannel,
        this.videoUrl,
        this.liveVideoUrl,
        // this.logoUrl,
        this.description,
        // this.channelName,
        this.subscriberCount,
        this.videoCount,
        this.likesCount,
        this.totalViewCount
    ];


    constructor(data?: {
        listenToChannel?: any,
        videoUrl?: any,
        liveVideoUrl?: any,
        // logoUrl?: any,
        description?: any,
        // channelName?: any,
        subscriberCount?: any,
        videoCount?: any,
        likesCount?: any,
        totalViewCount?: any
    }) {
        if(data?.listenToChannel){
            this.listenToChannel.value = data.listenToChannel.value;
        }
        if(data?.videoUrl){
            this.videoUrl.value = data.videoUrl.value;
        }
        if(data?.videoUrl){
            this.videoUrl.value = data.videoUrl.value;
        }
        if(data?.liveVideoUrl){
            this.liveVideoUrl.value = data.liveVideoUrl.value;
        }
        // if(data?.logoUrl){
        //     this.logoUrl.value = data.logoUrl.value;
        // }
        if(data?.description){
            this.description.value = data.description.value;
        }
        // if(data?.channelName){
        //     this.description.value = data.description.value;
        // }
        if(data?.subscriberCount){
            this.subscriberCount.value = data.subscriberCount.value;
        }
        if(data?.videoCount){
            this.videoCount.value = data.videoCount.value;
        }
        if(data?.likesCount){
            this.likesCount.value = data.likesCount.value;
        }
        if(data?.totalViewCount){
            this.totalViewCount.value = data.totalViewCount.value;
        }

    }
}